import { fetcher } from "helpers/fetcher";

import { TGetNotesReq, TGetNotesRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getNotes = async (payload: TGetNotesReq) => {
  return await fetcher<TGetNotesRes, TGetNotesReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_NOTES_HISTORY,
    {
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
      },
      data: payload.data,
      urlData: payload.urlData,
    }
  );
};

export const queryGetNotes = async (payload: TGetNotesReq) => {
  return (await getNotes(payload)).data;
};

queryGetNotes._key = (payload?: TGetNotesReq) => [
  ENDPOINT.MANAGEMENT.GET_NOTES_HISTORY.url,
  payload,
];
